import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as Trainings } from '../../components/icons/vid-oct.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import { ReactComponent as NumSort } from '../../components/icons/num-sort.svg';
import { ReactComponent as AlphaSort } from '../../components/icons/alpha-sort.svg';
import { ReactComponent as Cup } from '../../components/icons/cup.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton.jsx';
import CustomInput from '../../components/components/custom_input/customInput.jsx';
import store from '../../store/store.js'; // Import magazynu Redux
import { clearCheckedItems, toggleNeedRefresh, setKeyword, setSearchValue, setSortListEndpoint} from '../../store/trainingsTabSlice';
import ApiService from '../../components/api_services/apiService';
import { changeSortingListConfiguration } from './trainingsTableService.js';

// Akcje dla tabeli użytkowników
export const actions = {  
  // addSport: () => {
  //   console.log('Dodaj sport kliknięte');
  //   handleOpenModal;
  //   // Logika otwierania modala lub przekierowania do formularza dodawania sportu
  // },
 deleteSelected: async (dispatch) => {
    // Pobierz `checkedItems` ze stanu Redux    
    const state = store.getState();
    const selectedIds = state.trainings.checkedItems;

    if (selectedIds.length === 0) {
      alert('Nie wybrano żadnych elementów do usunięcia.');
      return;
    }

    try {
      // const response = await ApiService.deleteSportsByIdList(selectedIds);
      //
      // // Obsługa odpowiedzi serwera
      // if (response.status === 200) {
      //   alert('Wszystkie sporty zostały usunięte!');
      // } else if (response.status === 206) {
      //   alert('Niektóre sporty nie mogły zostać usunięte!');
      // } else if (response.status === 204) {
      //   alert('Nie znaleziono sportów do usunięcia!');
      // }
      //
      // // Wyzerowanie zaznaczonych elementów
      // dispatch(clearCheckedItems());
      // dispatch(toggleNeedRefresh());

    } catch (error) {      
      // console.error('Błąd podczas usuwania sportów:', error);
      // alert('Wystąpił błąd podczas usuwania sportów.');
    }
  },
  // searchUsers: (query) => {
  //   console.log('Wyszukaj użytkowników:', query);
  //   // Logika wyszukiwania użytkowników
  // },
  // changeTab: (tabName, dispatch, setActiveUsersTab) => {
  //   console.log('Zmieniono zakładkę na:', tabName);
  //   dispatch(setActiveUsersTab(tabName));
  // },
};

// Konfiguracja nagłówków tabeli

export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rows, checkedItems) => [
  <input
    type="checkbox"
    checked={rows.every((row) => checkedItems.includes(row[1]))}
    onChange={(e) => {
      if (e.target.checked) {
        // Dodaj wszystkie widoczne elementy do checkedItems
        rows.forEach((row) => {
          if (!checkedItems.includes(row[1])) {
            dispatch({ type: 'trainings/toggleCheckedItem', payload: row[1] });
          }
        });
      } else {
        // Usuń wszystkie widoczne elementy z checkedItems
        rows.forEach((row) => {
          if (checkedItems.includes(row[1])) {
            dispatch({ type: 'trainings/toggleCheckedItem', payload: row[1] });
          }
        });
      }
    }}
    />,
    <div className="table-columns-headers">
    <div>ID</div>
    <SortArrows
      upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'id') {
          dispatch(setSorting({ sortBy: 'id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Nazwa treningu</div>
    <SortArrows
      upColor={sortBy === 'title' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'title' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'title') {
          dispatch(setSorting({ sortBy: 'title', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'title', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Data treningu</div>
    <SortArrows
      upColor={sortBy === 'planedStartDate' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'planedStartDate' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'planedStartDate') {
          dispatch(setSorting({ sortBy: 'planedStartDate', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'planedStartDate', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  // <div className="table-columns-headers">
  //   <div>Lokalizacja</div>
  // </div>,
  <div className="table-columns-headers">
    <div>Dyscyplina</div>
    <SortArrows
        upColor={sortBy === 'sportId' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
        downColor={sortBy === 'sportId' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
        className="menu-icon"
        onClick={() => {
          if (sortBy !== 'sportId') {
            dispatch(setSorting({ sortBy: 'sportId', sortDirection: 'ASC' }));
          } else {
            if (sortDirection === 'ASC') {
              dispatch(setSorting({ sortBy: 'sportId', sortDirection: 'DESC' }));
            } else {
              dispatch(setSorting({ sortBy: null, sortDirection: null }));
            }
          }
        }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Status</div>
    <SortArrows
      upColor={sortBy === 'trainingStatus' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'trainingStatus' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'trainingStatus') {
          dispatch(setSorting({ sortBy: 'trainingStatus', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'trainingStatus', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

export const empty = [];

// Szerokości kolumn
export const headerWidths = ['42px', '65px', '2fr', '1fr', '1fr', '1fr', '120px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: Trainings,
    name: 'Wszystkie treningi',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Wszystkie treningi' ? 'is-active' : '',
    onClick: () => {},
    toggleActive: true,
  },
];


// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword('')); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      },
    },
  },
];